<template>
    <b-modal
      v-model="open"
      ref="newProduct"
      size="xl"
      centered
      title="Adicionar produto"
      header-bg-variant="orange"
      header-text-variant="light"
      ok-title="Fechar"
      ok-variant="danger"
      ok-only
      no-close-on-backdrop
    >
      <h4 class="text-center mb-4">Dados do produto</h4>
      <b-row>
        <b-col cols="12" class="mb-4 imgWidth" v-if="product.item">
          <img
            :src="
              linkFotos(product.item.origem) +
              product.item.produto_fotos[0].foto_png
            "
            :alt="product.item.produto"
            class="imgWidth"
          />
        </b-col>
        
        <b-col cols="12" class="mb-3 text-center">
          <span class="title">{{ title }}</span>
        </b-col>

        <b-col cols="12" class="mb-2 text-center" v-if="product.item">
          <span class="fs-18" > <strong>Código de barras: </strong>{{ product.item.codbar }}</span>
        </b-col>

        <b-col cols="12" class="mb-2 text-center" v-if="product.item">
          <span class="fs-18" > <strong>Marca: </strong>{{ product.item.marca }}</span>
        </b-col>
      </b-row>
  
      <b-row>
        <b-col cols="12" md="6">
          <label>Preço</label>
          <InputMoney
            class="mt-1"
            v-model="fields.money"
          />
        </b-col>
        <b-col cols="12" md="6" class="mt-3 pt-3">
          <b-button block @click="customPrice()" variant="secondary">
            <i class="fas fa-tag mr-2"></i>
            Preço customizado
          </b-button>
        </b-col>
        
        <b-col cols="12" md="6" class="mt-3">
          <label>Cod. Interno</label>
          <b-input
            v-mask="['##########']"
            v-model="fields.codeProduct"
            @blur="validCod()"
            @keyup.enter="validCod()"
          ></b-input>
        </b-col>
  
        <b-col cols="12" md="6" class="mt-4">
          <label>Desconto à vista (%)</label>
          <b-input
          placeholder="%"
            v-model="fields.discount"
            v-mask="['##']"
          ></b-input>
        </b-col>
      
        <b-col cols="6" class="mt-4">
          <label>Entrega 24hrs</label>
          <b-form-checkbox
            switch
            v-model="fields.isDelivery"
          >
          </b-form-checkbox>
        </b-col>
  
        <b-col cols="6" class="mt-4">
          <label>Gerenciar Estoque</label>
          <b-form-checkbox
            type="number"
            v-model="fields.isStock"
            switch
          >
          </b-form-checkbox>
          
          <b-input
            class="mt-2"
            v-mask="['########']"
            v-if="fields.isStock"
            v-model="fields.qdteStock"
            placeholder="digite quantidade"
          >
          </b-input>
        </b-col>
        <b-col class="mt-4">
          <b-button @click="save()" variant="success" block>
            Salvar
          </b-button>
        </b-col>
      </b-row>
  
      <SetSelectedProductPrice
        ref="setSelectedProductPrice"
        @saved="handleSelectedProductPrice($event)"
        @delete="handleSelectedProductPriceDelete($event)"
      />
  
    </b-modal>
  
  </template>
  
  <script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { formatNumber } from '@/utils';
  
  import makeToast from '@/mixins/makeToast';
  
  import InputMoney from 'Components/Inputs/InputMoney.vue';
  import SetSelectedProductPrice from './SetSelectedProductPrice.vue';
  import UserTypes from '@/enums/UserTypes';
  
  export default {
    name: 'NewProductSmallWindow',
    mixins: [makeToast],
    emits:['updatePage'],
    
    components: {
      InputMoney,
      SetSelectedProductPrice
    },
  
    data() {
      return {
        loading: false,
        open: false,
        title: '',
        typeProduct: '',
        product: [],
        fields: {
          isStock: false,
          isDelivery: false,
          qdteStock: null,
          money: null,
          codeProduct: null,
          discount: null,
          customPrice: null
        }
      };
    },
    computed: {
      ...mapState(['dadosUsuario']),
      ...mapGetters('shopkeeper', ['getUserTypesEnabled']),
    },
    methods: {
      formatNumber,
      ...mapActions('shopkeeper', [
        'validarCodInternoLojista',
        'saveSelectedProducts'
      ]),
      toggleOpen({ data = [], type }) {
        this.product = data;
        this.typeProduct = type;
        this.title = data.item.produto
        this.open = !this.open;
      },
      customPrice(){
        this.$refs.setSelectedProductPrice.toggleOpen({
          selectedProductId: null,
          productName: this.product.item.produto,
          productId: this.product.item.id,
          alreadyCreatedPrices:this.fields.customPrice,
        });
      },
      
      validCod(){
        if (!this.fields.codeProduct) return;
  
        const data = {
          cod: this.fields.codeProduct,
          lojista_id: this.dadosUsuario.id,
        };
  
        this.loading = true;
        this.$store.dispatch('startLoader');
        this.validarCodInternoLojista(data)
          .then((response) => {
            if (response.data.data.cod == true) {
              this.fields.codeProduct = null;
              this.makeToast(
                'Oopss',
                'Esse código interno já está sendo usado!',
                'danger'
              );
            } else {
              this.makeToast('Sucesso', 'código interno disponível!', 'success');
            }
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
            this.loading = false;
          });
      },
  
      handleSelectedProductPrice(event) {
        if (!event.productId) return;
  
        if (!this.fields.customPrice) {
          this.fields.customPrice = [];
        }
  
        this.fields.customPrice.push({
          ...event,
        });
      },
      handleSelectedProductPriceDelete(event) {
        if (!event.productId) return;
  
        const currentCustomPrices =
        this.fields.customPrice || [];
  
        if (!currentCustomPrices.length) {
          return;
        }
      },

      save() {
        console.log('Entrei!');
        //return;
        if(this.fields.money == 'R$0,00'){
          this.makeToast('Oopss', 'O preço não pode estar vazio ou igual a zero', 'danger');
          return
        }
  
        if(this.fields.isStock && (!this.fields.qdteStock || this.fields.qdteStock <= 0)){
          this.makeToast('Oopss', 'você selecionou gerenciar stoque, o campo quantidade precisa estar preenchido!', 'danger');
          return
        }
        
        let orderProduct = {
          userId: this.userTypeId(),
          selectedProducts: [],
        };
  
        const data = {
          selectedProductId: this.product.item.id,
          priceSalesFormat1: this.fields.money,
          priceSalesFormat2: 0,
          quantityStock: this.fields.qdteStock,
          codInterno: this.fields.codeProduct ? this.fields.codeProduct : 0,
          quantityValid: this.fields.isStock,
          withdrawalInOneDay: this.fields.isDelivery ? this.fields.isDelivery : false,
          discont: this.fields.discount,
          customPrices: this.fields.customPrice,
          origem: this.typeProduct
        }
        
        orderProduct.selectedProducts.push(data);
  
        this.$store.dispatch('startLoader');
  
        this.saveSelectedProducts(orderProduct)
          .then(() => {
            this.makeToast('Sucesso', 'Produtos selecionados salvos com sucesso');
            this.$root.$emit('valid-available-app');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
            this.cleanData();
            this.$emit('updatePage');
            this.open = false;
          });
      },
      cleanData(){
        this.fields = {};
        this.product = [];
        this.typeProduct = '';
        this.title = '';
      },
      userTypeId() {
        return this.$route.meta.userType == UserTypes.BALCONISTA
          ? this.dadosUsuario.construp_user_id
          : this.dadosUsuario.id;
      },
      linkFotos(origem) {
        if (origem === 'Belenus') {
          return 'https://storage.googleapis.com/fotos-prd/';
        } 
        return process.env.VUE_APP_FOTOS_URL;
        
      },
    },
  };
  </script>
  
  <style scoped>
  .title {
    background-color: yellow;
    padding: 11px;
    border-radius: 10px;
    font-size: 17.5px;
    line-height: 25pt;
  }
  .imgWidth {
    width: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  </style>